import { getArtists, artistDirectoryElement } from './artistutils';
import './artistsmap.js'
import { favouritesEl } from './favourites'
import { addClickEvent } from './googletrack'


export class ArtistDirectory {
    constructor(artistDirectoryEl) {
        this.baseUrl = window.location.href.split("?")[0]
        this.artists = getArtists();
        this.listArtists = this.artists;
        this.mapArtists = this.artists.filter(artist => {
            return artist.coords && !artist.excludefrommap
        })
        //console.log("ArtistDirectory initialized with artists:", this.artists)
        this.artistDirectoryEl = artistDirectoryEl;
        this.displayselect = this.artistDirectoryEl.querySelector(".displayselect");
        this.dsList = this.displayselect.querySelector(".ds-list");
        this.dsMap = this.displayselect.querySelector(".ds-map");
        this.artistlist = this.artistDirectoryEl.querySelector(".artist-list");
        this.artistmap = this.artistDirectoryEl.querySelector(".artist-map");
        this.locationsEl = this.artistDirectoryEl.querySelector(".chkselect.location");
        this.mediumsEl = this.artistDirectoryEl.querySelector(".chkselect.mediums");
        this.iconsEl = this.artistDirectoryEl.querySelector(".chkselect.icons")
        this.searchEl = this.artistDirectoryEl.querySelector("#name");
        this.clearEl = this.artistDirectoryEl.querySelector(".clear");
        this.numResultsEl = this.artistDirectoryEl.querySelector(".artistlist-numresults");
        this.doFilter = true;
    }

    isMapView() {
        return this.artistmap.classList.contains("active");
    }

    isListView() {
        return this.artistlist.classList.contains("active");
    }

    setResultsCount(count) {
        let total = this.listArtists.length
        if (this.isMapView()) {
            total = this.mapArtists.length
        }
        let countStr = ""
        if (count < total) {
            countStr = `${count} of `
        }
        this.numResultsEl.textContent = `${countStr}${total} results`
    }

    setUrlFromSelections() {
        const url = new URL(window.location.href)
        const params = url.searchParams

        params.delete('location')
        params.delete('medium')
        params.delete('icons')

        this.locationsEl.querySelectorAll("input[type=checkbox]").forEach(checkbox => {
            if (checkbox.checked) {
                params.append('location', checkbox.value);
            }
        });

        this.mediumsEl.querySelectorAll("input[type=checkbox]").forEach(checkbox => {
            if (checkbox.checked) {
                params.append('medium', checkbox.value);
            }
        });

        this.iconsEl.querySelectorAll("input[type=checkbox]").forEach(checkbox => {
            if (checkbox.checked) {
                params.append('icons', checkbox.value);
            }
        });

        if (this.searchEl.value) {
            params.set('search', this.searchEl.value);
        } else {
            params.delete('search');
        }

        if (this.dsMap.classList.contains("active")) {
            params.set('map', 'true');
        } else {
            params.delete('map');
        }

        window.history.replaceState({}, "", url.toString());
    }


    setSelectionsFromUrl() {
        const params = new URLSearchParams(document.location.search);
        const icons = params.getAll('icons')
        if (icons) {
            //console.log("Setting icons from URL:", icons)
            this.iconsEl.querySelectorAll("input[type=checkbox]").forEach(checkbox => {
                if (icons.includes(checkbox.value)) {
                    checkbox.checked = true;
                }
            })
        }
        const locations = params.getAll('location')
        if (locations) {
            //console.log("Setting locations from URL:", locations)
            this.locationsEl.querySelectorAll("input[type=checkbox]").forEach(checkbox => {
                if (locations.includes(checkbox.value)) {
                    checkbox.checked = true;
                }
            })
        }
        const mediums = params.getAll('medium')
        if (mediums) {
            //console.log("Setting mediums from URL:", mediums)
            this.mediumsEl.querySelectorAll("input[type=checkbox]").forEach(checkbox => {
                if (mediums.includes(checkbox.value)) {
                    checkbox.checked = true;
                }
            })
        }
        const search = params.get('search')
        if (search) {
            this.searchEl.value = search;
        }
        const map = params.get('map')
        if (map === "true") {
            this.handleDisplaySelection(this.dsMap);
        }
    }

    artistSelection(href) {
        // Selected from map or list - save the current value
        this.url = new URL(window.location.href);

        console.log("Artist selected:", href, "old url", this.url.href)
        // Navigate to the artist page
        history.pushState(null, null, href)
    }


    backToList() {
        // NOTE: IF logged in as artist OR ADMIN backbutton.classList.contains("artist-access") == true
        // So goes back to bare URL -- See back button handling in artistprofile.js
        if (this.url) {
            history.pushState(null, null, this.url)
        } else {
            history.pushState(null, null, this.baseUrl)
        }
    }

    async init() {
        // See back button handling in artistprofile.js
        document.addEventListener("directory:backtolist", () => {
            this.backToList()
        })

        // handle click on artist
        this.artistlist.querySelectorAll(".artist").forEach(artistEl => {
            artistEl.addEventListener("click", (e) => {
                e.preventDefault()
                const logo = event.target.closest('.logo');
                if (!favouritesEl.clickedOnItinerary(e, logo)) {
                    //const itinerary = event.target.closest('.artist-itinerary');
                    //if (!itinerary) { // Itenerary handled by favourites
                    this.artistSelection(artistEl.href)
                    //history.pushState(null, null, artistEl.href)
                    console.log("Navigating to artist page:", artistEl.href)
                }
            })
        })
        // Create map
        const el = document.createElement('artist-map');
        this.artistmap.appendChild(el);
        this.map = el;
        //console.log("Awaiting map update")
        await el.updateComplete;
        this.map.artistSelectionCallback = (href) => this.artistSelection(href)
        //console.log("Map update complete")


        // Populate initial number of results
        this.setResultsCount(this.artists.length)

        // Add event listeners for display selection and filters
        this.dsMap.addEventListener("click", () => {
            addClickEvent("map_listselect", "Map")
            this.handleDisplaySelection(this.dsMap)
        });
        this.dsList.addEventListener("click", () => {
            addClickEvent("map_listselect", "List")
            this.handleDisplaySelection(this.dsList)
        });
        this.iconsEl.querySelectorAll(".chkoptions > div").forEach(item => {
            item.addEventListener("click", () => {
                item.querySelector("input[type=checkbox]").click();
            });
        });
        this.iconsEl.querySelectorAll("input[type=checkbox]").forEach(checkbox => {
            checkbox.addEventListener("change", () => {
                addClickEvent("icons_select", checkbox.value)
                this.handleFilterSearch()
            });
        })
        this.locationsEl.querySelectorAll(".chkoptions > div").forEach(item => {
            item.addEventListener("click", () => {
                item.querySelector("input[type=checkbox]").click();
            });
        });
        this.locationsEl.querySelectorAll("input[type=checkbox]").forEach(checkbox => {
            checkbox.addEventListener("change", () => {
                addClickEvent("location_select", checkbox.value)
                this.handleFilterSearch()
            });
        })
        this.mediumsEl.querySelectorAll(".chkoptions > div").forEach(item => {
            item.addEventListener("click", () => {
                item.querySelector("input[type=checkbox]").click();
            });
        });

        this.mediumsEl.querySelectorAll("input[type=checkbox]").forEach(checkbox => {
            checkbox.addEventListener("change", () => {
                addClickEvent("medium_select", checkbox.value)
                this.handleFilterSearch()
            });
        })
        this.searchEl.addEventListener('input', (event) => {
            //console.log('Current value:', event.target.value);
            this.handleFilterSearch();
        });
        this.clearEl.addEventListener("click", () => {
            addClickEvent("clear", "Artists Selections")
            this.doFilter = false
            this.clear()
            this.doFilter = true
            this.handleFilterSearch()
        })
        this.setSelectionsFromUrl() 
        this.handleFilterSearch()
    }

    clear() {
        this.locationsEl.querySelectorAll("input[type=checkbox]").forEach(checkbox => {
            checkbox.checked = false
        })
        this.mediumsEl.querySelectorAll("input[type=checkbox]").forEach(checkbox => {
            checkbox.checked = false
        })
        this.searchEl.value = ""
        this.setResultsCount(this.artists.length)
        this.handleNumSelected()
    }

    handleNumSelected() {
        const locationItemsEl = this.locationsEl.querySelector(".numitems");
        const selectedLocations = this.locationsEl.querySelectorAll("input[type=checkbox]:checked").length;
        if (selectedLocations > 0) {
            locationItemsEl.querySelector(".number").textContent = selectedLocations;
            locationItemsEl.style.display = "";
        } else {
            locationItemsEl.style.display = "none";
        }

        const mediumItemsEl = this.mediumsEl.querySelector(".numitems");
        const selectedMediums = this.mediumsEl.querySelectorAll("input[type=checkbox]:checked").length;
        if (selectedMediums > 0) {
            mediumItemsEl.querySelector(".number").textContent = selectedMediums;
            mediumItemsEl.style.display = "";
        } else {
            mediumItemsEl.style.display = "none";
        }

        const iconsItemsEl = this.iconsEl.querySelector(".numitems");
        const selectedicons = this.iconsEl.querySelectorAll("input[type=checkbox]:checked").length;
        if (selectedicons > 0) {
            iconsItemsEl.querySelector(".number").textContent = selectedicons;
            iconsItemsEl.style.display = "";
        } else {
            iconsItemsEl.style.display = "none";
        }
    }

    getAllDisplayedArtists() {
        return this.isMapView() ? this.mapArtists : this.listArtists;
    }

    handleFilterSearch() {
        if (!this.doFilter) return
        this.setUrlFromSelections()
        const artists = this.getAllDisplayedArtists();
        const locations = [];

        this.locationsEl.querySelectorAll("input[type=checkbox]").forEach(checkbox => {
            if (checkbox.checked) {
                locations.push(checkbox.value);
            }
        })
        //console.log("Locations:", locations)
        let filteredArtists = locations.length == 0 ? artists : artists.filter(artist => {
            return locations.includes(artist.location);
        });
        const mediums = [];
        this.mediumsEl.querySelectorAll("input[type=checkbox]").forEach(checkbox => {
            if (checkbox.checked) {
                mediums.push(checkbox.value);
            }
        })
        filteredArtists = mediums.length == 0 ? filteredArtists : filteredArtists.filter(artist => {
            return mediums.includes(artist.medium);
        })
        const icons = [];
        this.iconsEl.querySelectorAll("input[type=checkbox]").forEach(checkbox => {
            if (checkbox.checked) {
                icons.push(checkbox.value);
            }
        })
        if (icons.length) {
            filteredArtists.forEach(a => {
                a.iconInclude = false
            })
            icons.forEach(icon => {
                if (icon == "newToTrail") {
                    filteredArtists.forEach(a => {
                        a.iconInclude = a.iconInclude || a.newToTrail
                    })
                }
                if (icon == "awardWinning") {
                    filteredArtists.forEach(a => {
                        a.iconInclude = a.iconInclude || a.awardWinning
                    })
                }
                if (icon == "accessible") {
                    filteredArtists.forEach(a => {
                        a.iconInclude = a.iconInclude || a.accessible
                    })
                }
                if (icon == "valuedMember") {
                    filteredArtists.forEach(a => {
                        a.iconInclude = a.iconInclude || a.valuedMember
                    })
                }
                if (icon == "openLabourDay") {
                    filteredArtists.forEach(a => {
                        a.iconInclude = a.iconInclude || a.openLabourDay
                    })
                }
                if (icon == "openYearRound") {
                    filteredArtists.forEach(a => {
                        a.iconInclude = a.iconInclude || a.openYearRound
                    })
                }
            })
            filteredArtists = filteredArtists.filter(artist => {
                return artist.iconInclude;
            })
        }
        //console.log(filteredArtists[0])
        if (this.searchEl.value) {
            // Normalize and remove accents from the search term
            const searchTerm = this.searchEl.value
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '');

            const artistByListingNumber = filteredArtists.filter(artist => {
                return "#" + artist.listingNumber == searchTerm || "#" + artist.listingNumber == "#" + searchTerm
            })
            if (artistByListingNumber.length) {
                filteredArtists = artistByListingNumber
            } else {
                filteredArtists = filteredArtists.filter(artist => {
                    // Normalize and remove accents from the artist name
                    const artistName = artist.fullName
                        .toLowerCase()
                        .normalize('NFD')
                        .replace(/[\u0300-\u036f]/g, '')
                    const summary = artist.summary
                        .toLowerCase()
                        .normalize('NFD')
                        .replace(/[\u0300-\u036f]/g, '')

                    return artistName.includes(searchTerm) || summary.includes(searchTerm) || "#" + artist.listingNumber == searchTerm;
                });
            }

        }
        this.map.setArtists(filteredArtists);
        this.setList(filteredArtists);
        //console.log("Filtered artists:", filteredArtists)
        this.setResultsCount(filteredArtists.length)
        this.handleNumSelected()
        //console.log("Filtered artists:", filteredArtists)
    }

    setList(artists) {
        //console.log("Setting list with artists:", artists)
        this.artistlist.querySelectorAll(".artist").forEach(artistEl => {
            const artist = artists.find(a => a.id === artistEl.dataset.artistid);
            if (!artist) {
                artistEl.classList.add("hide");
            } else {
                artistEl.classList.remove("hide");
            }
        })
        //this.handleFilterSearch
    }

    handleDisplaySelection(element) {
        if (element === this.dsList) {
            this.dsMap.classList.remove("active");
            this.dsList.classList.add("active");
            this.artistlist.classList.add("active");
            this.artistmap.classList.remove("active");
        } else if (element === this.dsMap) {
            this.dsMap.classList.add("active");
            this.dsList.classList.remove("active");
            this.artistlist.classList.remove("active");
            this.artistmap.classList.add("active");
            this.map.show()
        }
        this.handleFilterSearch()
        //this.setResultsCount(this.getAllDisplayedArtists().length)
    }
}
const artistDirectoryEl = artistDirectoryElement();
if (artistDirectoryEl) {
    const ad = new ArtistDirectory(artistDirectoryEl);
    ad.init()
}
